import { useMediaQuery, useTheme } from '@material-ui/core';

export const useMobile = (): boolean => {
  const theme = useTheme();
  return useMediaQuery(`(max-width:${theme.breakpoints.values[theme.breakpoints.keys[1]]}px)`, {
    noSsr: true,
  });
};
